import { useMemo } from 'react'

import type { Activity } from '../../lib/apollo/types'

const useHours: (activity: Activity)  => string = (activity) => useMemo(() =>
    new Date(activity.date).toLocaleTimeString(navigator.language, { hour: '2-digit', minute:'2-digit' })
, [activity.date])

export default useHours
